//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import { SITE_KEY } from '../App';
import * as choiceApi from '../api/choice';

export function ResetPassPanel() {
    const [ , setLoadingRecaptcha ] = useState(false);
    const [ username, setUserName ] = useState(process.env.REACT_APP_MEMBER_NUMBER ?? "");
    const [ saving, setSaving ] = useState(false);
    const [ email, setEmail ] = useState("");
    const [ msg, setMsg ] = useState("");

    let navigate = useNavigate();
    let location = useLocation();

    const onSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        setLoadingRecaptcha(true);
        window.grecaptcha.ready(async () => {
            try {
                const token = await window.grecaptcha.execute(SITE_KEY, { action: 'submit' });
                const userInfo = await choiceApi.resetPassword(username, email, token);
                // console.log(userInfo);
                setMsg("Please check your email for your temporary password")
            }
            catch (err) {
                console.log(err);
                setMsg(err?.response?.data?.message)
            }
            setLoadingRecaptcha(false);
            setSaving(false);
        });
    }

    const showReset = (location.hash === "#reset-password" || location.hash === "#activate-account");


    const title = (location.hash === "#activate-account") ? "Activate Account" : "Reset Password";

    const alert = msg ? <Alert className="mt-3" variant="danger">{msg}</Alert> : null;

    return (
        <Offcanvas className="login-panel" show={showReset} placement="end" onHide={() => navigate(-1)}>
            <Offcanvas.Header closeVariant="white" closeButton>
                <Offcanvas.Title></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-4">
                    <div className="d-flex flex-column justify-content-between h-100">
                        <div>
                            <h1>{title}</h1>

                            {alert}
                            <Form onSubmit={onSubmit}>

                                <div className='mt-3'>Membership ID</div>
                                <FormControl value={username} onChange={(e) => setUserName(e.target.value)} />

                                <div className='mt-3'>Email</div>
                                <FormControl type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

                                <div className='mt-4'>
                                    <Button className='w-100' type='submit'>{title}</Button>
                                </div>
                            </Form>
                        </div>

                        <div>
                            <div className="d-flex justify-content-between">
                                <Link className='w-100' to='#signin' replace><Button className='w-100' variant="outline-primary">Sign In</Button></Link>
                            </div>
                            
                        </div>

                    
                    </div>


            </Offcanvas.Body>
        </Offcanvas>
    )

}